import Table from '@/components/table/components/Table.tsx';
import { clientsApiQueryKeys } from '@/features/dashboard/clients/api/clientsApi.queryKeys.ts';
import clientsApi from '@/features/dashboard/clients/api/clientsApi.ts';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import { RowWithId } from '@/components/table/types/RowWithId.ts';
import { useNavigate } from '@tanstack/react-router';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';
import { clientsRoute } from '@/features/dashboard/clients/routes/clientsRoute.ts';

const ClientsTable = () => {
  const navigate = useNavigate();
  const search = clientsRoute.useSearch();

  const rowContextMenuItems: RowContextMenuItemParams<RowWithId>[] = [
    {
      label: 'Szczegóły',
      action: (row) =>
        navigate({
          to: '/app/clients/$clientId/info',
          params: { clientId: row.id },
        }),
    },
  ];

  return (
    <Table
      listSearch={search}
      queryKey={clientsApiQueryKeys.all()}
      fetchData={clientsApi.getClients}
      fetchTableDef={clientsApi.getTableDefinition}
      rowContextMenuItems={rowContextMenuItems}
      bulkActions={[]}
      tagTargetType={TaggableType.CLIENT}
      title="Zapisujący"
    />
  );
};

export default ClientsTable;
